import { useGet } from './useFetch'
import { useAuth } from './useAuth'

interface UseTodayAdPlayCountParams {
  adId?: number
  clinicId?: number
  broadcastDeviceId?: number
  supplierId?: number
}

interface TodayAdPlayCountResponse {
  success: boolean
  count: number
}

export function useTodayAdPlayCount(params: UseTodayAdPlayCountParams = {}) {
  const { token } = useAuth()
  const query = [
    params.adId !== undefined ? `adId=${params.adId}` : null,
    params.clinicId !== undefined ? `clinicId=${params.clinicId}` : null,
    params.broadcastDeviceId !== undefined ? `broadcastDeviceId=${params.broadcastDeviceId}` : null,
    params.supplierId !== undefined ? `supplierId=${params.supplierId}` : null,
  ]
    .filter(Boolean)
    .join('&')
  const url = token ? `/api/ad-play/daily/today${query ? `?${query}` : ''}` : null
  const { data, error, mutate } = useGet<TodayAdPlayCountResponse>(url, undefined, token ?? '')

  return {
    count: data?.count ?? 0,
    isLoading: !error && !data,
    isError: error,
    mutate,
  }
}
